import React from 'react';
import { Col, Button } from 'antd';

const containerStyle = { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' };

export function Fallback({ fallBackMessage }) {
	return (
		<Col span={24} className="main" style={containerStyle}>
			<Button type="primary" onClick={() => window.location.reload()}>
				Retry
			</Button>
			<h3 style={{ color: '#213242', marginTop: '1.2rem' }}>{fallBackMessage}</h3>
		</Col>
	);
}
